import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import Home from '../../../home/home';
import Section from '../../../section/section';
import Wrapper from '../pages-wrapper';
import LoginRedirect from '../../../commons/login-redirect';
// import banner from '../../../../images/banner-ead.png';
import banner from '../../../../images/banner-teste-pratico-ead.png';
import CredentialsHelper from '../../../../utils/credentials-helper';
import routes from '../../../../utils/routes';
import InternalPageTypes from '../../internal-page-types';
import { fetchCoachData } from './coach-pages.actions';

const SectionWithClasses = connect(
    ({ App }) => ({
        classes: App.classes,
        idProp: 'classId',
        links: [{ title: 'Cursos', url: routes.COACH_CLASSES }],
        pageType: InternalPageTypes.CLASS_RESOURCE,
    })
)(Section);

class CoachPages extends React.Component {

    componentDidMount() {
        if (CredentialsHelper.isLoggedIn) {
            this.props.fetchCoachData();
        }
    }

    render() {
        if (!CredentialsHelper.isLoggedIn) {
            return <LoginRedirect/>;
        }
        const isHomePath = this.props.location.pathname === routes.HOME;
        return (
            <div className='body-wrapper'>
                {isHomePath && <Banner/>}
                <Wrapper
                    pageType={isHomePath ? InternalPageTypes.HOME_RESOURCE : InternalPageTypes.CLASS_RESOURCE}>
                    <Switch>
                        <Route path={routes.HOME} component={Home}/>
                        { !this.props.loadingCourses && <Route path={routes.RESOURCES(':id')} component={SectionWithClasses}/>}
                        <Redirect to={routes.HOME}/>
                    </Switch>
                </Wrapper>
            </div>
        );
    }
}

const mapStateToProps = ({ App }) => {
    return {
        loadingCourses: App.loadingCourses,
    };
};

export default connect(
    mapStateToProps,
    dispatch => bindActionCreators({ fetchCoachData }, dispatch),
)(CoachPages);

class Banner extends React.Component {
    render() {
        return (
            <div className='banner'>
                <a href='https://cdn.scisapp.com/downloads/ead/TUTORIAL.pdf' target='_blank' rel='noopener noreferrer'>
                    <img src={banner} alt='Banner'/>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/internal-pages/components/coach-pages/coach-pages.js